import { render, staticRenderFns } from "./add-agency.vue?vue&type=template&id=322aa2a6"
import script from "./add-agency.vue?vue&type=script&lang=js"
export * from "./add-agency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports